import { Renderer as ArmatureRenderer }   from '@geenee/armature';
import { GeetrackerSlamProcessingResult } from '@geenee/shared/src/magellan/processor/processor';

export class Renderer extends ArmatureRenderer<GeetrackerSlamProcessingResult | any> {
    constructor() {
        super();
    }
}
